import script from "./CookieConsentPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieConsentPanel.vue?vue&type=script&setup=true&lang=js"

import "./CookieConsentPanel.vue?vue&type=style&index=0&id=0bc364f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc364f2"]])

export default __exports__